import React from 'react';
import { Outlet } from 'react-router-dom';
import { useMyTeamData } from './hooks/useMyTeamData';

export const MyTeamPage: React.FC = () => {
  useMyTeamData();

  return <Outlet />;
};
